import { SUPPORT_EMAIL_MAIL_TO } from "@/constants"
import { Component } from "@/types/types"
import { ButtonLink } from "@/ui/atoms/controls/ButtonLink"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { Pill } from "@/ui/atoms/data/Pill"
import { SplashCard } from "@/ui/atoms/layout/SplashCard"
import { Stack } from "@/ui/atoms/layout/Stack"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { NotificationCard } from "@/ui/blocks/notifications/NotificationCard"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "forgotPasswordConfirmation"

export const presets = {}

export interface Props extends Component {
  email: string
}

export function ForgotPasswordConfirmation({ email, className, testId = COMPONENT_NAME }: Props) {
  return (
    <SplashCard className={cx(`w-full max-w-screen-form text-center`, className)} testId={testId}>
      <Stack className="gap-8">
        <header>
          <Stack className="gap-6">
            <div className="flex justify-center items-center gap-2">
              <Title size="lg" className="text-center">
                Please check your email
              </Title>
              <Pill>Legacy</Pill>
            </div>

            <BodyText size="md">
              If the following email address exists in our system we have sent you an email.
              <br /> <span className="font-bold">{email}</span>
            </BodyText>
            <BodyText size="md">
              Simply click on the link in the email to set a new password. If you don’t receive an
              email from us, please check your spam folder.
            </BodyText>
          </Stack>
        </header>

        <footer>
          <Stack className="gap-6">
            <NotificationCard
              variant="warning"
              title="Not for SANS account users"
              text="Most users should now sign in via SANS. Signing in with your email and password will only work for certain legacy accounts created before September 25, 2025."
              links={[
                {
                  label: "Sign in with SANS",
                  href: "/sign-in",
                },
              ]}
              className="border border-border-form border-l-0"
            />
            <ButtonLink label="Return to sign in" variant="primary" href="/sign-in" width="full" />
            <TextLink href={SUPPORT_EMAIL_MAIL_TO} style="bold">
              Still haven't received an email? Contact us
            </TextLink>
          </Stack>
        </footer>
      </Stack>
    </SplashCard>
  )
}
